import { Pipe, PipeTransform, inject } from '@angular/core';
import { LOCALE_ID } from '@angular/core';

@Pipe({
  name: 'currency',
  standalone: false,
})
export class LocaleCurrencyPipe implements PipeTransform {
  locale = inject(LOCALE_ID);

  transform(value: number): any {
    return new Intl.NumberFormat(this.locale, {
      style: 'decimal',
      minimumFractionDigits: 2,
    }).format(value) /*+ ' грн'*/;
  }
}
